export const T = {
  en_GB: {
    addWebhook: "Add Webhook",
  },
  nb_NO: {
    addWebhook: "Legg til webhook",
  },
} as const;
